import React from 'react';

const SVG = ({ style = {}, on, color1, color2, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="alternate-right">
        <rect x="50" y="0" width="50" height="100" />
      </clipPath>
    </defs>
    <g>
      <circle cx="50" cy="50" r="46" stroke={color1} strokeWidth={8} />
      <circle cx="50" cy="50" r="20" fill={on ? color1 : 'none'} />
    </g>
    <g clipPath="url(#alternate-right)">
      <circle cx="50" cy="50" r="46" stroke={color2} strokeWidth={8} />
      <circle cx="50" cy="50" r="20" fill={on ? color2 : 'none'} />
    </g>
  </svg>
);

export default SVG;
